import React from 'react';

import Button from 'components/shared/Button/Button';

import srcImage from 'assets/Images/myriad-motion/e-prescribe-illustration.png';

const ActivationScreen = ({ onActivate, isLoading }) => {
  return (
    <div className="flex items-center justify-center">
      <div className="flex w-full max-w-[330px] flex-col items-center rounded-2xl border border-solid border-neutral-300 bg-white shadow-sm">
        <div className="w-full">
          <img
            src={srcImage}
            alt="e-Prescribe"
            className="h-auto w-full rounded-t-2xl object-contain"
          />
        </div>
        <div className="flex flex-col gap-2 p-6">
          <label className="w-full text-left text-xl font-500 leading-tight text-neutral-900">
            Activate e-Prescribe for your practice
          </label>
          <p className="mb-4 w-full text-left text-sm leading-relaxed text-neutral-600">
            This step activates your e-Prescribe profile and establishes your secure connection.
            After setup, you'll be able to enroll providers.
          </p>
          <Button
            text="Activate e-Prescribe"
            color="primary"
            onClick={onActivate}
            isLoading={isLoading}
            isDisabled={isLoading}
            className="w-full"
          />
        </div>
      </div>
    </div>
  );
};

export default ActivationScreen;
